module.exports = __webpack_public_path__ + "img/m2_t2_bg.6e138ada.svg";